"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAfterCreateRecipe = exports.createRecipeMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../../user/fragments/meUser");
const recipePreviewFragment_1 = require("../fragments/recipePreviewFragment");
const recipesByCookbookAndSectionId_1 = require("../queries/recipesByCookbookAndSectionId");
const createRecipeAllCookbooks_1 = require("./graphqlUpdates/createRecipeAllCookbooks");
const createRecipeGetRecipeById_1 = require("./graphqlUpdates/createRecipeGetRecipeById");
exports.createRecipeMutation = client_1.gql `
  mutation CreateRecipe($recipe: RecipeInput!) {
    createRecipe(recipe: $recipe) {
      __typename
      errors {
        path
        message
      }
      uploadUrl
      recipe {
        ...RecipePreview
      }
      user {
        ...meUser
      }
    }
  }
  ${meUser_1.meUserFragment}
  ${recipePreviewFragment_1.recipePreviewFragment}
`;
exports.updateAfterCreateRecipe = (variables, cookbookId) => (store, { data }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!data) {
        return;
    }
    const { createRecipe: { errors: errs, recipe }, } = data;
    if (errs || !recipe) {
        return;
    }
    if (variables.recipe.sectionId) {
        createRecipeAllCookbooks_1.createRecipeAllCookbooks(store, recipe, variables.recipe.sectionId, cookbookId);
        try {
            const recipesInSection = store.readQuery({
                query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                variables: {
                    sectionId: variables.recipe.sectionId,
                },
            });
            if (recipesInSection) {
                store.writeQuery({
                    query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                    variables: {
                        sectionId: variables.recipe.sectionId,
                    },
                    data: {
                        __typename: "Query",
                        recipesByCookbookAndSectionId: [
                            ...recipesInSection.recipesByCookbookAndSectionId,
                            recipe,
                        ],
                    },
                });
            }
        }
        catch (err) {
            if (process.env.NODE_ENV !== "production") {
                console.log(err);
            }
        }
    }
    createRecipeGetRecipeById_1.cRRecipeGetRecipeById(store, recipe);
});
//# sourceMappingURL=CreateRecipe.js.map